const account = ({ limit, totalItems }) => ({
    loading: false,
    showingResultCount: limit || 2,
    totalItems: totalItems || 0,
    init() {
        window.addEventListener("search-more", (event) => this.searchMore(event));
    },
    searchMore(event) {
        this.loading = true;
        fetch(event.detail.new_url)
            .then(response => response.text())
            .then(data => {
                let html_div = document.createElement('div');
                html_div.innerHTML = data;

                const button = document.querySelector('#order-pagination .button');
                const href = button.getAttribute('href');
                const url = new URL(href, window.location.origin);
                const pageValue = url.searchParams.get('page');
                if (pageValue && parseInt(pageValue) === parseInt(button.getAttribute('data-total-pages'))) {
                    document.querySelector('#order-pagination').style.display = 'none';
                }

                let html_dom = html_div.querySelector('#order-list').innerHTML;

                if (document.querySelector('#order-list')) {
                    document.querySelector('#order-list').innerHTML += html_dom;
                }

                this.showingResultCount = document.querySelectorAll('.overview-order').length;

                if (html_div.querySelector('#order-pagination')) {
                    let pagination_dom = html_div.querySelector('#order-pagination').innerHTML;
                    if (document.querySelector('#order-pagination')) {
                        document.querySelector('#order-pagination').innerHTML = pagination_dom;
                    }
                }
            })
            .catch(error => console.error('Error:', error))
            .finally(() => this.loading = false);
    }
});

export default account;